import {Injectable} from "@angular/core";
import {select, Store} from "@ngrx/store";
import {AppState} from "src/app/core/core.module";
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {selectAllMensaje} from "../store/entities/shared/mensajes/mensajes.selectors";
import {Mensaje} from "../../chacra-core/models/mensaje";

@Injectable({
  providedIn: 'root'
})
export class MensajesService {

  newMessages$ = new BehaviorSubject<number>(null);

  constructor(
    private store: Store<AppState>,
  ) {

    combineLatest([
      this.store.pipe(select(selectAllMensaje)),
    ])
      .subscribe(([mensajes]) => {
          this.change(mensajes);
        }
      )
  }

  change(mensajes: Mensaje[]) {
    let m = mensajes.filter(m => !m.mensajeLeido);
    this.launchNewMessage(m.length);
  }

  launchNewMessage(cant: number): void {
    this.newMessages$.next(cant);
  }

  watchNewMessage(): Observable<number> {
    return this.newMessages$;
  }
}
